<template>
  <drag-modal :visible="visible" @cancel="reset" :title="edit ? '编辑被告' : '新增被告'" width="584px">
    <div class="newly">
      <div class="form">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="被告类型" prop="type" v-if='!isOther'>
            <a-select v-model="form.type" placeholder="请选择" :disabled='isEdit("type")'
              :class='{ "yellow": isEdit("type") }'>
              <a-select-option :value="1">个人</a-select-option>
              <a-select-option :value="2">企业</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="isOther ? '姓名' : '被告'" prop="realname">
            <a-input v-model="form.realname" :disabled='isEdit("realname")' :class='{ "yellow": isEdit("realname") }' />
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="chinaid"
            :rules="[{ required: true, trigger: 'blur', validator: form.type == 1 ? Validator.nChinaid : null }]">
            <a-input v-model="form.chinaid" :maxLength="18" :disabled='isEdit("chinaid")'
              :class='{ "yellow": isEdit("chinaid") }' @blur="getSex(form.chinaid)" />
          </a-form-model-item>
          <a-form-model-item label="被告性别：" prop="sex">
            <a-select v-model="form.sex" placeholder="请选择" :disabled='isEdit("sex")'
              :class='{ "yellow": isEdit("sex") }'>
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label='关联原告' prop='accuser_id'>
            <a-select v-model="form.accuser_id" placeholder="请选择" style="width: 100%;" :disabled='isEdit("accuser_id")'
              :class='{ "yellow": isEdit("accuser_id") }'>
              <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="联系方式" prop="phone">
            <a-input v-model="form.phone" :maxLength="20" :disabled='isEdit("phone")'
              :class='{ "yellow": isEdit("phone") }' />
          </a-form-model-item>
          <a-form-model-item label="户籍地：" prop="citys">
            <a-cascader :options="options" placeholder="请选择"
              :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model='form.citys'
              :disabled='isEdit("province_id,city_id,area_id")'
              :class='{ "yellow": isEdit("province_id,city_id,area_id") }' />
            <a-input v-model="form.addr" type='textarea' style="margin-top:20px;" placeholder="请输入被告详细地址"
              :disabled='isEdit("addr")' :class='{ "yellow": isEdit("addr") }' />
          </a-form-model-item>
          <a-form-model-item label="备注：" prop="comment" v-if='!isOther'>
            <a-input v-model="form.comment" type='textarea' placeholder="请填写备注" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width:108px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:108px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </drag-modal>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { citySort } from '@/assets/js/unit'
import { letters, getAccuserAll } from '@/server/api'
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {

        }
      }
    },
    isOther: Boolean
  },
  data() {
    return {
      Validator,
      visible: false,
      edit: false,
      accuserList: [],
      accuser: {
        title: ''
      },
      audit: [],   //在修改中的字段
      options: citySort(city),
      rules: {
        realname: [{ required: true, message: '请输入被告姓名', trigger: 'blur' }],
        phone: [{ required: true, trigger: ['blur', 'change'], validator: Validator.validateContact }],
        citys: [{ required: false, trigger: 'change', message: '请选择户籍地' }],
        type: [{ required: true, trigger: 'change', message: '请选择被告类型' }],
        accuser_id: [{ required: true, trigger: 'change', message: '请选择关联原告' }]
      },
      form: {
        sex: null,
        type: 1,
        citys: [],
        realname: '',
        chinaid: '',
        phone: '',
        addr: '',
        accuser_id: '',
        comment: ''
      }
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          this.form = {
            id: newVal.id,
            citys: newVal.province_id ? [newVal.province_id, newVal.city_id, newVal.area_id] : [],
            comment: newVal.comment,
            addr: newVal.addr,
            chinaid: newVal.chinaid,
            realname: newVal.realname,
            phone: newVal.phone,
            sex: newVal.sex,
            relation: newVal.relation,
            type: newVal.type,
            accuser_id: newVal.accuser_id,
          }
          this.edit = true
        } else {
          this.form = {
            sex: null,
            type: 1,
            citys: [],
            realname: '',
            chinaid: '',
            phone: '',
            addr: '',
            accuser_id: '',
            comment: ''
          }
          this.edit = false
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  methods: {
    isEdit(val) {
      let bool = this.audit.filter(ele => {
        return val.split(",").indexOf(ele.field) >= 0
      }).length > 0 ? true : false;
      return bool
    },
    getSex(UUserCard) {
      this.form.sex = parseInt(UUserCard.substr(16, 1)) % 2 == 1 ? 1 : 2
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          if (form.citys.length > 0) {
            form.province_id = form.citys[0];
            form.city_id = form.citys[1];
            form.area_id = form.citys[2];
            delete form.citys
          }
          if (this.isOther) {
            delete form.type
            delete form.comment
            form.debtor_id = this.$route.params.id
          }
          letters(this.edit ? 'edit' : 'add', form).then(() => {
            this.$message.success(this.edit ? '修改成功' : '新增成功')
            this.$emit('resh')
            this.reset()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.form.addr = ''
      this.$refs.forms.resetFields();
      this.visible = false;
    },
  }
}
</script>
<style lang="less" scoped>
.newly {
  .form {
    width: 100%;
    margin: 0 auto;
  }

  background: #fff;
}
</style>